var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":_vm.absolute,"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"size":100,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }